import { Theme } from "../constants/index.js";
import { PageContextUtils } from "./pageContextUtils.js";

export class BrandUtils {
  static isPokerClient = () => {
    const { name } = PageContextUtils.getClientProviderData();

    return name === "Poker";
  };

  static isSiSportsBook = () => {
    const themeData = PageContextUtils.getThemeData();
    return themeData?.currentName === Theme.SportsIllustrated;
  };

  static isMrGreen = () => {
    const themeData = PageContextUtils.getThemeData();
    return themeData?.currentName === Theme.MrGreen;
  };
}
